export default __webpack_public_path__ + "static/media/gourds.7447a244.gif";